namespace $.$$ {
	
	type $shm_hitalama_textbook_toc_item = {
		readonly id: string
		readonly level: number
		readonly title: string
	}
	
	export class $shm_hitalama_textbook extends $.$shm_hitalama_textbook {
		
		@ $mol_mem
		toc_items() {
			const items = [] as $shm_hitalama_textbook_toc_item[]
			
			for( const match of this.text().matchAll( /^(#{1,6})[ \t]+(.+)$/gm ) ) {
				const title = match[2].trim()
				items.push({
					id: String( items.length ),
					level: match[1].length,
					title,
				})
			}
			
			return items
		}
		
		@ $mol_mem
		toc_rows() {
			return this.toc_items()
				.filter( item => !this.toc_parent( item.id ) )
				.map( item => this.Toc_node( item.id ) )
		}
		
		@ $mol_mem_key
		toc_node_rows( id: string ) {
			return [
				this.Toc_row( id ),
				... this.toc_expanded( id ) && this.toc_expandable( id ) ? [ this.Toc_children( id ) ] : [],
			]
		}
		
		toc_item( id: string ) {
			return this.toc_items()[ Number( id ) ]
		}
		
		toc_title( id: string ) {
			return this.toc_item( id ).title
		}
		
		toc_level( id: string ) {
			return this.toc_item( id ).level
		}
		
		@ $mol_mem
		toc_parents() {
			const parents = {} as Record< string, string | null >
			const stack = [] as $shm_hitalama_textbook_toc_item[]
			
			for( const item of this.toc_items() ) {
				while( stack.length && stack[ stack.length - 1 ].level >= item.level ) stack.pop()
				parents[ item.id ] = stack[ stack.length - 1 ]?.id ?? null
				stack.push( item )
			}
			
			return parents
		}
		
		toc_parent( id: string ) {
			return this.toc_parents()[ id ]
		}
		
		@ $mol_mem_key
		toc_children( id: string ) {
			return this.toc_items()
				.filter( item => this.toc_parent( item.id ) === id )
				.map( item => this.Toc_node( item.id ) )
		}
		
		toc_arg( id: string ) {
			return {
				[ this.text_param() ]: this.toc_title( id ),
			}
		}
		
		toc_expandable( id: string ) {
			return this.toc_children( id ).length > 0
		}
		
		text_title() {
			return this.toc_items()[0]?.title ?? super.text_title()
		}
		
	}
	
}
